export class H5Langding {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.name = form.name;
      this.coverImage = {
        lpPicture: form.coverImage.lpPicture, // LP图片
        shareCardImage: form.coverImage.shareCardImage, // 上传图片
      };
      this.needLogIn = form.needLogIn;
      this.linkTo = form.linkTo;
      this.coverImage.shareCardImage = form.coverImage.shareCardImage;
    } else {
      this.clear();
    }
  }

  clear() {
    this.id = null;
    this.name = "";// 标题
    this.coverImage = {
      lpPicture: "", // LP图片
      shareCardImage: "", // 上传图片
    };
    this.needLogIn = 0; // 是否需要登录后访问
    this.linkTo = ""; // 跳转URL
  }
}
